<mat-toolbar class="topbar gap-8">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if(showToggle) {
  <button mat-icon-button
          (click)="toggleCollapsed.emit()"
          class="d-flex justify-content-center">
    <i-tabler name="align-left" class="icon-20 d-flex"></i-tabler>
  </button>
  <div class="text-left " *ngIf="SwitchCharity">
    <!--*ngIf="this.SwitchCharity"-->
    <button mat-button aria-label="Switch Charity" class="bgwhite b-0 cust-header-btn" style="height: 50px;" (click)="openCharities(template)">
      <div class="d-flex align-items-center gap-10">
        <div class="text-left">
          <h4 class="f-s-14 f-w-400 text-left text-black-50" [ngClass]="{ 'textoverflow': currentCharityName?.length > 10}">
            <span class="f-s-14 f-w-600 p-l-0 text-black"><div matTooltip="{{currentCharityName}}" style="text-overflow: ellipsis; width: 150px !important; overflow: hidden;">  {{currentCharityName}}</div></span>
          </h4>
          <p class="text-left m-0 m-t--6">{{currentRegistrainNumber}} </p>
        </div>
        <i-tabler class="icon-16 m-l-10" name="chevron-down"></i-tabler>
      </div>
    </button>
  </div>
  }

  <!-- Open charities -->
  <ng-template #template>
    <!--*ngIf="this.SwitchCharity"-->
    <mat-card style="margin-bottom: 0px !important; overflow-x: hidden !important;">
      <mat-card-content class="p-16">
        <div class="p-b-10">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <mat-card-title class="mat-mdc-card-title">
                <h4 class="f-s-26 f-w-700">Select Charity</h4>
                <p class="f-s-12 m-0">Choose a charity to work on</p>
              </mat-card-title>
            </div>
            <div class="col-lg-6 text-right">
              <div class="d-flex justify-content-end align-items-center">
                <!--<button mat-flat-button color="primary">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-16" name="plus"></i-tabler> Create Charity
                  </div>
                </button>-->
                <button class="text-center btn-close-dialog" mat-dialog-close>
                  <i-tabler class="icon-20 m-r-2" name="X"></i-tabler>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0 m-t-0">
          <div class="charities-list" style="max-height: 450px; overflow-y: auto;">
            <div class="m-b-0 b-t-1 p-y-10" style="border-radius: 0px; box-shadow: none; margin-bottom: 0px !important;">
              <div class=" cust-charity-lists" style="border-radius: 0px;" *ngFor="let element of CharityGrid">
                <!--<div class="d-flex align-items-start gap-10" (click)="viewcharity(element.charityID)"  [ngClass]="{ 'activebox': element.charityID== CurrentcharityID}">-->
                <div class="d-flex align-items-start gap-10 p-10 m-t-10"
                     (click)="element.charityID !== CurrentcharityID && viewcharity(element.charityID)"
                     [ngClass]="{ 'activebox': element.charityID == CurrentcharityID }"
                     [style.pointer-events]="element.charityID == CurrentcharityID ? 'none' : 'auto'"
                     [style.opacity]="element.charityID == CurrentcharityID ? '0.6' : '1'">
                  <div class="icon icon-38 rounded d-flex align-items-center justify-content-center bg-white text-primary b-1" style="min-width: 6%;">
                    <i-tabler name="building" class="icon-24 d-flex"></i-tabler>
                  </div>
                  <div class="info">
                    <h5 class="f-w-700 lh-sm f-s-14" style="cursor: pointer; overflow-wrap: anywhere !important;">
                      {{element.charity_Name}}
                    </h5>
                    <div class="d-flex align-items-center gap-15">
                      <p class="f-w-400 lh-sm f-s-14 m-0">Charity Registration Number - {{ element.charity_Registration_Number}}</p>
                      <!--|<p class="f-w-400 lh-sm f-s-14 m-0">{{ element.charity_Type}}</p>-->
                      <!--<p class="f-w-400 lh-sm f-s-14 m-0">{{ element.jurisdiction_Charity=='england_wales'?'England and Wales':element.jurisdiction_Charity=='scotland'?'Scotland': element.jurisdiction_Charity=='northern_ireland'?'Northern Ireland':2}}</p>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <button mat-flat-button color="primary" class="cust-add-switch add-charity text-white f-w-600 f-s-16 w-100 " (click)="addcharity()">
            <div class="d-flex align-items-center">
              <i-tabler class="icon-18" name="plus"></i-tabler> Add Charity
            </div>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>



  <!-- Mobile Menu -->
  @if(!showToggle) {
  <button mat-icon-button
          (click)="toggleMobileNav.emit()"
          class="d-flex justify-content-center">
    <i-tabler name="align-left" class="icon-20 d-flex"></i-tabler>
  </button>
  <span class="flex-1-auto"></span>
  <div class="justify-content-center moband">
    <img src="./assets/images/logos/logo-dark.svg" style="height:24px !important" />
  </div>

  }
  <!--<img src="../../../assets/images/logos/logo-dark.svg" width="150" class="landingdone" />-->
  <!-- --------------------------------------------------------------- -->
  <!--<div class="d-none d-lg-flex">-->
  <!-- --------------------------------------------------------------- -->
  <!--  Links -->
  <!-- --------------------------------------------------------------- -->
  <!--<button mat-button
          [matMenuTriggerFor]="appsmenu"
          aria-label="Notifications">
    <div class="d-flex align-items-center">
      Apps <i-tabler name="chevron-down" class="icon-16 m-l-4"></i-tabler>
    </div>
  </button>
  <mat-menu #appsmenu="matMenu" class="apps-dd cardWithShadow">
    <div class="row">
      <div class="col-sm-8 b-r-1 p-r-0">
        <div class="p-32 p-b-0">
          <div class="row">
            @for(appdd of apps; track appdd.title) {
            <div class="col-sm-6 text-hover-primary">
              <a [routerLink]="[appdd.link]"
                 class="d-flex align-items-center text-decoration-none m-b-24">
                <span class="text-primary bg-light-primary rounded icon-40 d-flex align-items-center justify-content-center">
                  <img [src]="appdd.img" width="20" />
                </span>

                <div class="m-l-16">
                  <h5 class="f-s-14 f-w-600 m-0 textprimary hover-text">
                    {{ appdd.title }}
                  </h5>
                  <span class="text-body f-s-12">{{ appdd.subtitle }}</span>
                </div>
              </a>
            </div>
            }
          </div>
        </div>
        <div class="b-t-1 p-24 d-none d-lg-flex align-items-center justify-content-between">
          <span class="d-flex align-items-center f-s-16 f-w-500">
            <i-tabler name="help" class="icon-20 m-r-8"></i-tabler>Frequently
            Asked Questions
          </span>
          <a [routerLink]="['/theme-pages/faq']"
             mat-flat-button
             color="primary">Check</a>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="p-x-16 p-y-32">
          <h4 class="f-s-18 f-w-600 m-b-16">Quick Links</h4>
          @for(quicklink of quicklinks; track quicklink.title) {
          <div class="text-hover-primary">
            <a [routerLink]="[quicklink.link]"
               class="hover-text text-decoration-none text-body f-w-600 d-block p-y-8">{{ quicklink.title }}</a>
          </div>
          }
        </div>
      </div>
    </div>
  </mat-menu>-->
  <!-- <a mat-button [routerLink]="['/apps/chat']">Chat</a>
  <a mat-button [routerLink]="['/apps/calendar']">Calendar</a>
  <a mat-button [routerLink]="['/apps/email/inbox']">Email</a> -->
  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!--<button [matMenuTriggerFor]="flags"
            mat-icon-button
            class="m-l-10 d-none d-lg-flex align-items-center justify-content-center">
      <img [src]="selectedLanguage.icon"
           class="rounded-circle object-cover icon-20" />
    </button>
    <mat-menu #flags="matMenu" class="cardWithShadow">
      @for(lang of languages; track lang) {
      <button mat-menu-item (click)="changeLanguage(lang)">
        <div class="d-flex align-items-center">
          <img [src]="lang.icon"
               class="rounded-circle object-cover m-r-8 icon-20" />
          <span class="f-s-14">{{ lang.language }}</span>
        </div>
      </button>
      }
    </mat-menu>

  </div>-->

  <span class="flex-1-auto"></span>

  <!-- Mobile Menu -->
  <button mat-icon-button
          (click)="toggleMobileFilterNav.emit()"
          class="d-flex d-lg-none justify-content-center">
    <i-tabler name="grid-dots" class="icon-20 d-flex"></i-tabler>
  </button>

  <!-- --------------------------------------------------------------- -->
  <!--  Search -->
  <!-- --------------------------------------------------------------- -->
  <!--<button mat-stroked-button
          class="d-none d-lg-flex custom-outline-btn"
          (click)="openDialog()">
    <div class="d-flex align-items-center">
      <i-tabler name="search" class="icon-20 d-flex m-r-10"></i-tabler> Try to
      Searching...
    </div>
  </button>-->
  <!-- --------------------------------------------------------------- -->
  <!-- light / dark icon -->
  <!-- --------------------------------------------------------------- -->
  <!--@if(options.theme=='light'){
  <button mat-icon-button
          aria-label="lightdark"
          class="d-flex justify-content-center"
          (click)="setlightDark('dark')">
    <i-tabler class="d-flex icon-22" [name]="'moon'"></i-tabler>
  </button>
  }@else{
  <button mat-icon-button
          aria-label="lightdark"
          class="d-flex justify-content-center"
          (click)="setlightDark('light')">
    <i-tabler class="d-flex icon-22" [name]="'sun'"></i-tabler>
  </button>
  }-->
  <!-- --------------------------------------------------------------- -->
  <!-- Collpase bar -->
  <!-- --------------------------------------------------------------- -->
  <!--<button mat-icon-button
          (click)="toggleCollpase()"
          class="d-flex d-lg-none justify-content-center">
    <i-tabler name="dots" class="icon-20 d-flex"></i-tabler>
  </button>
  @if(isCollapse){
  <div class="header-collpase p-y-10 p-x-15">
    <div class="d-flex align-items-center justify-content-center gap-10">-->
  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!--<button [matMenuTriggerFor]="flags" mat-icon-button>
    <img [src]="selectedLanguage.icon"
         class="rounded-circle object-cover icon-20" />
  </button>-->
  <!-- --------------------------------------------------------------- -->
  <!-- shortcut Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!--<button mat-icon-button
          [matMenuTriggerFor]="notificationMenu"
          aria-label="Notifications">
    <i-tabler class="d-flex" name="layout-grid-add"></i-tabler>
    <div class="pulse">
      <span class="heartbit border-success"></span>
      <span class="point bg-success"></span>
    </div>
  </button>-->
  <!-- --------------------------------------------------------------- -->
  <!-- Messages Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!--<button mat-icon-button
          [matMenuTriggerFor]="msgMenu"
          aria-label="Messages">
    <i-tabler class="d-flex" name="message-2"></i-tabler>
    <div class="pulse">
      <span class="heartbit border-primary"></span>
      <span class="point bg-primary"></span>
    </div>
  </button>-->
  <!-- --------------------------------------------------------------- -->
  <!-- Profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!--<button mat-fab
              extended
              color="inherit"
              [matMenuTriggerFor]="profileMenu"
              class="profile-btn"
              aria-label="Notifications">
        <div class="d-flex align-items-center gap-12">
          <img src="/assets/images/profile/user5.jpg"
               class="rounded-circle object-cover"
               width="40" />
          <div class="d-none d-lg-flex text-left flex-col">
            <h5 class="f-s-16 f-w-600">Mike Nielsen</h5>
            <span class="f-s-14">Admin</span>
          </div>
        </div>
      </button>
    </div>
  </div>
  }-->
  <!-- --------------------------------------------------------------- -->
  <!-- Messages Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!--<button mat-icon-button
          [matMenuTriggerFor]="msgMenu"
          aria-label="Messages"
          class="d-none d-lg-block align-items-center justify-content-center">
    <i-tabler class="d-flex" name="message-2"></i-tabler>
    <div class="pulse">
      <span class="heartbit border-primary"></span>
      <span class="point bg-primary"></span>
    </div>
  </button>
  <mat-menu #msgMenu="matMenu"
            xPosition="before"
            class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-12">
      <h6 class="f-s-16 f-w-600 m-0">Messages</h6>
      <span class="m-l-16">
        <span class="bg-warning text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">5 new</span>
      </span>
    </div>

    @for(notification of notifications; track notification.title) {
    <button mat-menu-item class="p-x-32 p-y-12">
      <div class="d-flex align-items-center">
        <img [src]="notification.img" class="rounded-circle" width="48" />
        <div class="m-l-16">
          <h5 class="f-s-14 f-w-600 m-0">
            {{ notification.title }}
          </h5>
          <span>{{ notification.subtitle }}</span>
        </div>
      </div>
    </button>
    }

    <div class="p-y-12 p-x-32">
      <button mat-flat-button color="primary" class="w-100">
        See All Messages
      </button>
    </div>
  </mat-menu>-->
  <!-- --------------------------------------------------------------- -->
  <!-- Shortcuts Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!--<button mat-icon-button
          [matMenuTriggerFor]="notificationMenu"
          aria-label="Notifications"
          class="d-none d-lg-block align-items-center justify-content-center">
    <i-tabler class="d-flex" name="layout-grid-add"></i-tabler>
    <div class="pulse">
      <span class="heartbit border-success"></span>
      <span class="point bg-success"></span>
    </div>
  </button>
  <mat-menu #notificationMenu="matMenu"
            xPosition="before"
            class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-12">
      <h6 class="f-s-16 f-w-600 m-0">Shortcuts</h6>
    </div>
    <div class="row m-x-0">
      <div class="col-6 p-x-0">
        <a class="bg-light-primary-hover d-flex justify-content-center flex-col gap-8 text-decoration-none p-x-20 p-y-12 text-center b-t-1 b-b-1 b-r-1"
           [routerLink]="['/apps/invoice']">
          <div class="icon-45 bg-light-success rounded-circle m-auto round d-flex align-items-center justify-content-center">
            <i-tabler name="list-check" class="icon-20 text-success"></i-tabler>
          </div>
          <h6 class="f-s-16 f-w-600 m-0 text-body">Invoice</h6>
          <p class="d-block m-0 text-body f-w-500">Get latest invoice</p>
        </a>
      </div>
      <div class="col-6 p-x-0">
        <a class="bg-light-primary-hover d-flex justify-content-center flex-col gap-8 text-decoration-none p-x-20 p-y-12 text-center b-t-1 b-b-1"
           [routerLink]="['/apps/chat']">
          <div class="icon-45 bg-light-primary rounded-circle m-auto round d-flex align-items-center justify-content-center">
            <i-tabler name="message-2" class="icon-20 text-primary"></i-tabler>
          </div>
          <h6 class="f-s-16 f-w-600 m-0 text-body">Chat</h6>
          <p class="d-block m-0 text-body f-w-500">New messages</p>
        </a>
      </div>
      <div class="col-6 p-x-0">
        <a class="bg-light-primary-hover d-flex justify-content-center flex-col gap-8 text-decoration-none p-x-20 p-y-12 text-center b-b-1 b-r-1"
           [routerLink]="['/apps/contact-list']">
          <div class="icon-45 bg-light-secondary rounded-circle m-auto round d-flex align-items-center justify-content-center">
            <i-tabler name="phone-call"
                      class="icon-20 text-secondary"></i-tabler>
          </div>
          <h6 class="f-s-16 f-w-600 m-0 text-body">Contact</h6>
          <p class="d-block m-0 text-body f-w-500">2 Unsaved Contacts</p>
        </a>
      </div>
      <div class="col-6 p-x-0">
        <a class="bg-light-primary-hover d-flex justify-content-center flex-col gap-8 text-decoration-none p-x-20 p-y-12 text-center b-b-1"
           [routerLink]="['/apps/email/inbox']">
          <div class="icon-45 bg-light-error rounded-circle m-auto round d-flex align-items-center justify-content-center">
            <i-tabler name="mail" class="icon-20 text-error"></i-tabler>
          </div>
          <h6 class="f-s-16 f-w-600 m-0 text-body">Email</h6>
          <p class="d-block m-0 text-body f-w-500">Get new emails</p>
        </a>
      </div>
      <div class="col-6 p-x-0">
        <a class="bg-light-primary-hover d-flex justify-content-center flex-col gap-8 text-decoration-none p-x-20 p-y-12 text-center b-r-1"
           [routerLink]="['/apps/todo']">
          <div class="icon-45 bg-light-warning rounded-circle m-auto round d-flex align-items-center justify-content-center">
            <i-tabler name="edit" class="icon-20 text-warning"></i-tabler>
          </div>
          <h6 class="f-s-16 f-w-600 m-0 text-body">ToDo</h6>
          <p class="d-block m-0 text-body f-w-500">Daily tasks</p>
        </a>
      </div>
      <div class="col-6 p-x-0">
        <a class="bg-light-primary-hover d-flex justify-content-center flex-col gap-8 text-decoration-none p-x-20 p-y-12 text-center"
           [routerLink]="['/apps/calendar']">
          <div class="icon-45 bg-light-success rounded-circle m-auto round d-flex align-items-center justify-content-center">
            <i-tabler name="calendar" class="icon-20 text-success"></i-tabler>
          </div>
          <h6 class="f-s-16 f-w-600 m-0 text-body">Calendar</h6>
          <p class="d-block m-0 text-body f-w-500">Get dates</p>
        </a>
      </div>
    </div>
  </mat-menu>-->
  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->

  <img src="../../../../../assets/images/logos/logomini-dark.png" width="30" height="30" alt="Andica Logo" (click)="navigateToAndicaCentral()" />

  <button mat-fab
          extended
          color="inherit"
          [matMenuTriggerFor]="profileMenu"
          aria-label="Notifications"
          class="profile-btn d-none p-l-6 d-lg-flex align-items-center justify-content-center">
    <div class="d-flex align-items-center gap-12 b-l-1 p-l-15">


      <div class="rounded-circle object-cover avatartop" width="40" *ngIf="!ProfilePic"> {{ this.authService.userFullName?.charAt(0)?.toUpperCase() }}{{ this.authService.userFullName?.split(' ')[1]?.charAt(0)?.toUpperCase() }}</div>

      <img class="rounded-circle object-cover avatartop" width="40" [src]="ProfilePic" *ngIf="ProfilePic">

      <div class="d-none d-lg-flex text-left flex-col">
        <h5 class="f-s-16 f-w-600 username">{{this.authService.userFullName}}</h5>

      </div>
    </div>
  </button>
  <mat-menu #profileMenu="matMenu"
            xPosition="before"
            class="topbar-dd cardWithShadow">
    <ng-scrollbar class="position-relative" style="height:350px;" [ngStyle]=" this.authService.userEmail?.length > 28 && {'width': '400px'}" id="header">
      <div class="p-x-32 p-y-12">
        <div class="d-flex align-items-start p-b-14 b-b-1 m-t-14">
          <div class="rounded-circle object-cover avatartop ss  text-center"
               width="40"> {{ this.authService.userFullName?.charAt(0).toUpperCase() }}{{ this.authService.userFullName?.split(' ')[1]?.charAt(0)?.toUpperCase() }}</div>
          <div class="m-l-16">
            <h6 class="f-s-16 f-w-600 m-0 username" title="">{{this.authService.userFullName}}<span class="f-s-14 text-body m-b-4"></span></h6>
            <div class="hoverblock" *ngIf="this.authService.userFullName?.length > 16"> {{this.authService?.userFullName}}</div>
            <span class="d-flex align-items-start">
              <i-tabler name="mail" class="icon-18 m-r-5"></i-tabler>

              <span style=" width: 100%; text-wrap: auto; word-break: break-all;">  {{this.authService.userEmail}}</span>

            </span>
          </div>
        </div>
      </div>
      <div class="p-x-32">
        @for (profile of profiledd; track profile.title) {
        <ng-container *ngIf="profile.link?.startsWith('http'); else internalLink">
          <!-- External link -->
          <a class="p-y-10 text-decoration-none d-block text-hover-primary"
             style="cursor:pointer"
             [href]="profile.link"
             target="_blank"
             rel="noopener noreferrer">
            <div class="d-flex align-items-center gap-12">
              <span class="text-{{ profile.color }} bg-light-{{ profile.color }} icon-20 d-flex align-items-center justify-content-center shadow-none rounded">
                <i-tabler [name]="profile.img" class="icon-20"></i-tabler>
              </span>
              <div>
                <h5 class="f-s-14 f-w-600 m-0 textprimary hover-text">
                  {{ profile.title }}
                </h5>
              </div>
            </div>
          </a>
        </ng-container>

        <ng-template #internalLink>
          <!-- Internal link or action -->
          <a class="p-y-10 text-decoration-none d-block text-hover-primary"
             style="cursor:pointer"
             [routerLink]="profile.id !== 2 ? profile.link : null"
             (click)="profile.id === 2 || profile.id === 1|| profile.id === 5 ? profile.action() : null">
            <div class="d-flex align-items-center gap-12">
              <span class="text-{{ profile.color }} bg-light-{{ profile.color }} icon-20 d-flex align-items-center justify-content-center shadow-none rounded">
                <i-tabler [name]="profile.img" class="icon-20"></i-tabler>
              </span>
              <div>
                <h5 class="f-s-14 f-w-600 m-0 textprimary hover-text">
                  {{ profile.title }}
                </h5>
              </div>
            </div>
          </a>
        </ng-template>
        }


        <div>

          <a class="p-y-10 text-decoration-none d-block text-hover-primary"
             style="cursor:pointer"
             (click)="openHelp()">

            <div class="d-flex align-items-center gap-12">

              <span class="icon-20 d-flex align-items-center justify-content-center">
                <i-tabler name="helicopter-landing" class="icon-20"></i-tabler>
              </span>

              <div>
                <h5 class="f-s-14 f-w-600 m-0 textprimary hover-text">
                  Help
                </h5>
              </div>

            </div>

          </a>
          

        </div>

          <ng-template #internalLink>
            <!-- Internal link or action -->
            <a class="p-y-10 text-decoration-none d-block text-hover-primary"
               style="cursor:pointer"
               [routerLink]="profile.id !== 2 ? profile.link : null"
               (click)="profile.id === 2 || profile.id === 1|| profile.id === 5 ? profile.action() : null">
              <div class="d-flex align-items-center gap-12">
                <span class="text-{{ profile.color }} bg-light-{{ profile.color }} icon-20 d-flex align-items-center justify-content-center shadow-none rounded">
                  <i-tabler [name]="profile.img" class="icon-20"></i-tabler>
                </span>
                <div>
                  <h5 class="f-s-14 f-w-600 m-0 textprimary hover-text">
                    {{ profile.title }}
                  </h5>
                </div>
              </div>
            </a>
          </ng-template>

        </div>






      <div class="p-y-12 p-x-32">
        <button mat-flat-button color="primary" class="w-100 logout" (click)="logout()"> Logout </button>
      </div>
    </ng-scrollbar>
  </mat-menu>
</mat-toolbar>


<!--<ngx-spinner type="none" style="z-index:999 !important">
  <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
</ngx-spinner>-->
<mat-spinner strokeWidth="6" *ngIf="isLoadingResults">     </mat-spinner>
